import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";

import { DataService_batchupload } from "./shared/data.service";

import { SchoolService } from "../../../shared/services/school.service";
import { UserService } from "../../../shared/services/user.service";

import { PhotoInfo } from "./shared/PhotoInfo";
import { SchoolInfo } from "./shared/SchoolInfo";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

//
//	Javascript Function Declarations
//
declare const ResizeImageJS: Function;
declare const ResizeRotateImageJS: Function;

@Component({
	selector: "app-root",
	templateUrl: "./batchupload.component.html",
	styleUrls: ["./batchupload.component.css"],
	providers: [ConfirmationService],
})
export class BatchUploadComponent {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_batchupload,
		private schoolService: SchoolService,
		private userService: UserService,
		private confirmationService: ConfirmationService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private title = "Batch Photo Upload";
	private user: any;

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	Image Processing
	public TotalImagesLoaded: PhotoInfo[] = [];

	// 0 = [Selected Count]
	// 1 = [Selected Loaded Success Count]
	// 2 = [Selected Loaded Error Count]
	// 3 = [IsLoading]
	// 4 = [TotalImagesToUpload]
	// 5 = [TotalImagesUploaded]
	// 6 = [IsUploading]
	public SelectedCounts: any[] = [0, 0, 0, 0, 0, 0, 0];

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		// this.LoadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ClearImages
	//
	//-----------------------------------------------------------------------------------------------------
	ClearImages() {
		this.TotalImagesLoaded = [];
		this.SelectedCounts[0] = 0; //Selected Count
		this.SelectedCounts[1] = 0; //Selected Loaded Success Count
		this.SelectedCounts[2] = 0; //Selected Loaded Error Count
		this.SelectedCounts[3] = 0; //IsLoading
		this.SelectedCounts[4] = 0; //TotalImagesToUpload
		this.SelectedCounts[5] = 0; //TotalImagesUploaded
		this.SelectedCounts[6] = 0; //IsUploading
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GetData
	//
	//-----------------------------------------------------------------------------------------------------
	GetData() {
		this.dataService.getData().subscribe((data) => this.GetData_Callback(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GetData_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	GetData_Callback(data: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UploadImages
	//
	//-----------------------------------------------------------------------------------------------------
	ConfirmUploadImages(event: Event) {
		if (this.SelectedSchool.SchoolID > 0 && this.TotalImagesLoaded.length > 0) {
			//
			// Confirm Upload
			//
			var strWork = "";
			if (this.TotalImagesLoaded.length == 1) {
				strWork = "image";
			} else {
				strWork = "images";
			}

			var message =
				"You are about to upload " +
				this.TotalImagesLoaded.length +
				" " +
				strWork +
				" to " +
				this.SelectedSchool.SchoolName +
				".<br><br>" +
				"Do you wish to continue?";

			this.confirmationService.confirm({
				message: message,
				header: "Image Upload",
				icon: "fa fa-upload",
				accept: () => {
					this.UploadImages();
				},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UploadImages
	//
	//-----------------------------------------------------------------------------------------------------
	UploadImages() {
		console.log("Starting image upload..", new Date().toLocaleTimeString("en-US"));
		this.SelectedCounts[4] = this.TotalImagesLoaded.length;
		this.SelectedCounts[5] = 0;
		this.SelectedCounts[6] = 1;

		//
		// Upload 1st Photo (Start The Call Chain)
		//
		if (this.TotalImagesLoaded[0].PhotoIsUploaded == true) {
			this.UploadImages_Callback(0, null);
		} else {
			this.dataService.UploadImages(this.SelectedSchool.SchoolID, 0, this.TotalImagesLoaded[0]).subscribe((data) => this.UploadImages_Callback(0, data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	UploadImages_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	UploadImages_Callback(idx: number, data: any) {
		this.TotalImagesLoaded[idx].PhotoIsUploaded = true;
		this.SelectedCounts[5]++;

		//
		// Upload Next Photo
		//
		idx++;

		if (idx < this.TotalImagesLoaded.length) {
			if (this.TotalImagesLoaded[idx].PhotoIsUploaded == false) {
				this.dataService
					.UploadImages(this.SelectedSchool.SchoolID, idx, this.TotalImagesLoaded[idx])
					.subscribe((data) => this.UploadImages_Callback(idx, data));
			}
		} else {
			//
			//	Upload Complete
			//
			this.TotalImagesLoaded = [];
			this.SelectedCounts[0] = 0; //Selected Count
			this.SelectedCounts[1] = 0; //Selected Loaded Success Count
			this.SelectedCounts[2] = 0; //Selected Loaded Error Count
			this.SelectedCounts[6] = 0; //IsUploading

			console.log("Image upload complete..", new Date().toLocaleTimeString("en-US"));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadImages
	//
	//-----------------------------------------------------------------------------------------------------
	LoadImages(event: any) {
		console.log("Starting image load..", new Date().toLocaleTimeString("en-US"));

		this.SelectedCounts[0] = event.target.files.length; //Selected Count
		this.SelectedCounts[1] = 0; //Selected Loaded Success Count
		this.SelectedCounts[2] = 0; //Selected Loaded Error Count
		this.SelectedCounts[3] = 1; //IsLoading

		// If one or more image selected, Start the call chain to load all selected images)
		if (event.target.files && event.target.files[0]) {
			this.LoadImageAtIndex(event.target.files, 0);
		} else {
			this.SelectedCounts[3] = 0; //IsLoading
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadImageAtIndex
	//
	//-----------------------------------------------------------------------------------------------------
	LoadImageAtIndex(files: any, idx: any) {
		let reader = new FileReader();

		reader.onload = (e: any) => {
			this.ImageAtIndexLoaded(e, files, idx);
		};

		reader.readAsDataURL(files[idx]);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageAtIndexLoaded
	//
	//-----------------------------------------------------------------------------------------------------
	ImageAtIndexLoaded(e: any, files: any, idx: any) {
		//
		//	METHOD 1
		//
		//	Resize Image / Rotate Image / Push to TotalImagesLoaded[]
		//
		//this.ProcessResizeRotatePush(this.SelectedCounts, files[idx], e.target.result, this.TotalImagesLoaded, this.ResizeRotateImage);

		//
		//	METHOD 2	(Use This Method - Browsers now Rotate Image On-Load using Exif info in file)
		//
		//	Resize Image / Push to TotalImagesLoaded[]
		//
		this.ProcessResizePush(this.SelectedCounts, files[idx], e.target.result, this.TotalImagesLoaded);

		//
		// Are there more files left to load?
		//
		if (idx < files.length - 1) {
			// Yes, Load the next file
			this.LoadImageAtIndex(files, idx + 1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ProcessResizePush
	//
	//-----------------------------------------------------------------------------------------------------
	ProcessResizePush(SelectedCounts: any, imgfile: File, imgfiledata: any, TotalImagesLoaded: any) {
		ResizeImageJS(SelectedCounts, imgfile, imgfiledata, 640, TotalImagesLoaded);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ProcessResizeRotatePush
	//
	//-----------------------------------------------------------------------------------------------------
	ProcessResizeRotatePush(SelectedCounts: any, imgfile: File, imgfiledata: any, TotalImagesLoaded: any, callback: Function) {
		//
		// Note: Orientation: [-1] Not defined, [-2]: Not a jpeg
		//
		let reader = new FileReader();

		reader.onload = (event: ProgressEvent) => {
			if (!event.target) {
				// Not a jpeg
				return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, -2);
			}

			const file = event.target as FileReader;
			const view = new DataView(file.result as ArrayBuffer);

			// Is this file greater then 10 bytes
			if (view.byteLength <= 10) {
				// Not a jpeg
				return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, -2);
			}

			// Is this file a .jpg
			if (view.getUint16(0, false) != 0xffd8) {
				// Not a jpeg
				return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, -2);
			}

			const length = view.byteLength;
			let offset = 2;

			//Try To Get Orientation Exif Info from .Jpg
			while (offset < length) {
				if (view.getUint16(offset + 2, false) <= 8) {
					// No Exif in jpeg
					return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, -1);
				}

				let marker = view.getUint16(offset, false);
				offset += 2;

				if (marker == 0xffe1) {
					if (view.getUint32((offset += 2), false) != 0x45786966) {
						// No Exif in jpeg
						return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, -1);
					}

					let little = view.getUint16((offset += 6), false) == 0x4949;
					offset += view.getUint32(offset + 4, little);
					let tags = view.getUint16(offset, little);
					offset += 2;
					for (let i = 0; i < tags; i++) {
						if (view.getUint16(offset + i * 12, little) == 0x0112) {
							//	Found Exif in jpeg
							//
							//	Note: Degrees are reletive to clockwise rotation
							//
							//	1 = Image rotated 0°
							//	2 = Image rotated 0° + mirrored
							//	3 = Image rotated 180° or -180°
							//	4 = Image rotated 180° or -180° + mirrored
							//	5 = Image rotated -90° or 270° + mirrored
							//	6 = Image rotated -90° or 270°
							//	7 = Image rotated 90° or -270° + mirrored
							//	8 = Image rotated 90° or -270°
							//
							let orientation = view.getUint16(offset + i * 12 + 8, little);
							return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, orientation);
						}
					}
				} else if ((marker & 0xff00) != 0xff00) {
					break;
				} else {
					offset += view.getUint16(offset, false);
				}
			}

			// No Exif in jpeg
			return callback(SelectedCounts, imgfile, imgfiledata, TotalImagesLoaded, -1);
		};

		//
		//	Read The File
		//
		reader.readAsArrayBuffer(imgfile);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeRotateImage
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeRotateImage(SelectedCounts: any, imgfile: File, imgfiledata: any, TotalImagesLoaded: any, orientation: any) {
		ResizeRotateImageJS(SelectedCounts, imgfile, imgfiledata, orientation, 640, TotalImagesLoaded);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		// Do Nothing
		this.SelectedSchool = value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
